import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'
import Vue from 'vue'

const state = {
  paymentMethod: {},
  paymentMethods: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.paymentMethod = {
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, paymentMethod) => {
    state.paymentMethod = { ...paymentMethod }
    state.type = 'edit'
  },

  save: ({ state }, paymentMethod) => {
    const id = paymentMethod.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/paymentMethod/${id || ''}`, paymentMethod)
      .then((res) => {
        store.dispatch('paymentMethodStore/get')
        showSuccess('Forma de pagamento registrada com sucesso!')
        return res.data.id || paymentMethod.id
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/paymentMethod?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.paymentMethods = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/paymentMethod/${id}`).catch(showError),

  getByName: async ({ state }, name) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/paymentMethod?${getQueryFromFilter({ name })}`)
      .then(res => {
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/paymentMethod/${id}`)
      .then(_ => {
        store.dispatch('paymentMethodStore/handleRemove', id)
        showSuccess('Forma de pagamento excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  handleRemove: ({ state }, id) => {
    const paymentMethodIndex = state.paymentMethods.data.findIndex(i => String(i.id) === String(id))
    const data = state.paymentMethods.data

    if (paymentMethodIndex > -1) {
      // remove o item da lista
      data.splice(paymentMethodIndex, 1)

      // atualiza lista
      Vue.set(state.paymentMethods, 'data', data)
    }
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
